import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Collapse,
    Label,
    Row,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAdd,
    faChevronDown,
    faChevronUp,
    faSpinner,
    faTimes,
    faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import ControlledSelectForFiltering from "../../components/ContolledSelectForFiltering";
import ControlledTextField from "../../components/ControlledTextField";
import DataTable, { TableColumn } from "react-data-table-component";
import ButtonComponent from "../../components/ButtonComponent";
import { MenuItem } from "../../redux/menuSlice";
import Select from "react-select";
import { Badge } from "react-bootstrap";
import {
    CartData,
    Commissions,
    Products,
} from "../../views/Configuration/Commission";
import { toast } from "react-toastify";
import {
    DeleteCartItem,
    useDeleteCartCommissionMutation,
} from "../../redux/services/CommissionService";
import Swal from "sweetalert2";
import SavingButton from "../../components/SavingMessageComponent";
import './index.css';
import TableLoadingComponent from "../../components/TableLoadingComponent";

interface CartCommissionFormProps {
    errors: object;
    control: any;
    cartsList?: any;
    productsData?: any;
    productsItemsList?: any;
    onSubmit?: any;
    cartCommission: any;
    index: any;
    isNewCart: boolean;
    watch: any;
    commissions?: Commissions;
    setCommissions: any;
    setValue: any;
    selectedRestaurantId: string;
    restaurantCommissionWatcher: string;
    saveCommission: any;
    // deleteCart: (item: DeleteCartItem) => Promise<void>;
    newCartCommissionProduct?: Products[];
    systemDefaultCommission: number;
    setIsClickSave: any;
    setIsAddNewCart: any;
    // setErrorType?: React.Dispatch<React.SetStateAction<string>>;
    setIsErrorRestaurantCommission?: any;
    commissionData?: any;
}

const CartCommissionForm: React.FC<CartCommissionFormProps> = ({
    errors,
    control,
    cartsList,
    productsData,
    onSubmit,
    cartCommission,
    index,
    isNewCart,
    watch,
    commissions,
    setCommissions,
    setValue,
    selectedRestaurantId,
    restaurantCommissionWatcher,
    saveCommission,
    // deleteCart,
    newCartCommissionProduct,
    systemDefaultCommission,
    setIsClickSave,
    setIsAddNewCart,
    setIsErrorRestaurantCommission,
    commissionData,
}) => {


    const productCommissionWatcher = watch(`productCommission-${isNewCart ? `new` : cartCommission?.cartId}`);
    const cartCommissionWatcher = watch(`cartCommission-${isNewCart ? `new` : cartCommission?.cartId}`);
    const cartNameWatcher = watch(`cartName`);

    const updateCartIndex = commissions?.restaurantCartCommission.findIndex((cart: CartData) => cart?.cartId === cartCommission?.cartId);

    const newCartCommissionIndex = commissions?.restaurantCartCommission?.findIndex((cart: any) => cart?.isNewCreatedCart);

    const [deleteCartCommission] = useDeleteCartCommissionMutation();

    const [expandedSections, setExpandedSections] = useState<boolean>();
    const [selectedProduct, setSelectedProduct] = useState<MenuItem | null>(null);
    const [isAddButtonDisable, setIsAddButtonDisable] = useState<boolean>(true);

    const [isErrorCartCommission, setIsErrorCartCommission] =
        useState<boolean>(false);

    const [isErrorProductCommission, setIsErrorProductCommission] =
        useState<boolean>(false);

    const [isProductSelected, setIsProductSelected] = useState(false);

    const [isCartSave, setIsCartSave] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    // const [tempCommissions, setTempCommissions] = useState<
    //     Commissions | undefined
    // >();

    const [isDeleting, setIsDeleting] = useState(false);
    const [isCardVisible, setIsCardVisible] = useState(true);

    const toggleSection = () => {
        setExpandedSections(!expandedSections);
    };


    const handleAddProduct = () => {
        setIsSaving(false);
        if (
            productCommissionWatcher > cartCommissionWatcher &&
            cartCommissionWatcher > commissions?.systemDefaultCommission + 1 &&
            productCommissionWatcher > cartCommissionWatcher
        ) {
            if (selectedProduct) {

                const addProduct = {
                    menuItemId: selectedProduct.id,
                    commission: parseInt(productCommissionWatcher ?? "0", 10),
                    displayName: selectedProduct.displayName,
                    imageUrl: selectedProduct.imageUrl,
                };

                if (updateCartIndex !== -1) {
                    setCommissions((prev: Commissions) => {
                        return {
                            ...prev,
                            restaurantCartCommission: prev.restaurantCartCommission.map(
                                (cart, index) => {
                                    if (index === updateCartIndex) {
                                        const safeProducts = Array.isArray(cart.products)
                                            ? cart.products
                                            : [];

                                        return {
                                            ...cart,
                                            products: [...safeProducts, addProduct],
                                        };
                                    }

                                    return cart;
                                }
                            ),
                        };
                    });

                    setValue(`productCommission-${isNewCart ? `new` : cartCommission?.cartId}`, "");
                    setSelectedProduct(null);
                } else {

                    // add new cart commission list
                    const selectedCartIndex = cartsList.findIndex((cart: any) => cart?.id === cartNameWatcher?.value);

                    const obj = {
                        cartId: cartNameWatcher?.value,
                        cartName: cartNameWatcher?.label,
                        commission: parseInt(cartCommissionWatcher ?? "0", 10),
                        imageUrl: cartsList[selectedCartIndex]?.imageUrl,
                        products: [addProduct],
                        status: cartsList[selectedCartIndex]?.status,
                        isNewCreatedCart: true,
                    };

                    if (newCartCommissionIndex !== -1) {

                        setCommissions((prev: Commissions) => {
                            return {
                                ...prev,
                                restaurantCartCommission: prev.restaurantCartCommission.map(
                                    (cart, index) => {
                                        if (index === newCartCommissionIndex) {
                                            const safeProducts = Array.isArray(cart.products) ? cart.products : [];

                                            return {
                                                ...cart,
                                                products: [...safeProducts, addProduct],
                                            };
                                        }
                                        return cart;
                                    }
                                ),
                            };

                        });

                    } else {
                        setCommissions((prev: Commissions) => ({
                            ...prev,
                            restaurantCartCommission: [...prev.restaurantCartCommission, obj],
                        }));
                    }

                    setValue(
                        `productCommission-${isNewCart ? `new` : cartCommission?.cartId}`,
                        ""
                    );
                    setSelectedProduct(null);
                }
                setIsSaving(false);
                setIsErrorProductCommission(false);
            } else {
            }
        } else {
            // toast.error(
            //     "Product commissions should be higher than the cart commissions."
            // );
        }
    };

    const handleRemoveProduct = (product: Products) => {
        const updatedProductList = isNewCart
            ? (newCartCommissionProduct !== undefined
                ? newCartCommissionProduct
                : []
            ).filter((item) => item?.menuItemId !== product?.menuItemId)
            : commissions?.restaurantCartCommission[index]?.products?.filter(
                (item) => item?.menuItemId !== product?.menuItemId
            );

        setCommissions((prev: Commissions) => {
            if (updateCartIndex !== -1) {
                return {
                    ...prev,
                    restaurantCartCommission: prev.restaurantCartCommission.map(
                        (cart, index) => {
                            if (index === updateCartIndex) {
                                return {
                                    ...cart,
                                    products: updatedProductList,
                                };
                            }

                            return cart;
                        }
                    ),
                };
            } else {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const selectedCartIndex = cartsList.findIndex(
                    (cart: any) => cart?.id === cartNameWatcher?.value
                );

                return {
                    ...prev,
                    restaurantCartCommission: prev.restaurantCartCommission.map(
                        (cart, index) => {
                            if (index === newCartCommissionIndex) {
                                return {
                                    ...cart,
                                    products: updatedProductList,
                                };
                            }

                            return cart;
                        }
                    ),
                };
            }
        });
    };

    const handleSelectProduct = (option: MenuItem | null) => {
        if (option && option !== undefined) {
            setSelectedProduct(option);
            setIsProductSelected(true);
        } else {
            setIsProductSelected(false);
        }
    };

    const handleSaveCommission = () => {
        setIsClickSave(true);
        setIsCartSave(true);
        setIsSaving(true);

        if (commissions && commissions !== undefined && !isErrorProductCommission) {
            const obj = {
                restaurantId: selectedRestaurantId,
                restaurantCommission: parseInt(restaurantCommissionWatcher ?? "0", 10),
                cartId: isNewCart
                    ? cartNameWatcher?.value
                    : commissions?.restaurantCartCommission[index]?.cartId,
                cartCommission: isNewCart
                    ? parseInt(cartCommissionWatcher, 10)
                    : commissions?.restaurantCartCommission[index]?.commission,
                products:
                    commissions?.restaurantCartCommission[
                        isNewCart ? newCartCommissionIndex : index
                    ]?.products,
            };

            if (
                cartCommissionWatcher > restaurantCommissionWatcher &&
                restaurantCommissionWatcher > commissions?.systemDefaultCommission
            ) {
                saveCommission(obj);
                setCommissions((prev: Commissions) => {
                    return {
                        ...prev,
                        restaurantCartCommission: prev.restaurantCartCommission.map(
                            (cart, cartIndex) => {
                                if (
                                    cartIndex === (isNewCart ? newCartCommissionIndex : index)
                                ) {
                                    return {
                                        ...cart,
                                        products: [],
                                    };
                                }
                                return cart;
                            }
                        ),
                    };
                });
                setIsClickSave(false);
                setIsSaving(false);
            } else {
                setIsAddButtonDisable(true);

                if (
                    restaurantCommissionWatcher <= commissions?.systemDefaultCommission
                ) {
                    setIsErrorRestaurantCommission(true);
                } else if (cartCommissionWatcher <= restaurantCommissionWatcher) {
                } else {
                    toast.error("Somthing went Wrong ...");
                    setIsSaving(false);
                    setIsClickSave(false);
                }
            }
        }
    };

    const deleteCart = async (item: DeleteCartItem) => {
        setIsDeleting(true);
        try {
            const response = await deleteCartCommission(item).unwrap();
            toast.success("Your Cart has been deleted ..!");
            setIsDeleting(false);
            if (response) {
                setIsDeleting(false);
                const updatedCartList = commissions?.restaurantCartCommission.filter(
                    (cart) => cart.cartId !== item.cartId
                );

                setCommissions((prev: any) => {
                    setIsDeleting(false);
                    if (!prev) {
                        return {
                            systemDefaultCommission:
                                commissionData?.restaurantCommissionList
                                    ?.systemDefaultCommission,
                            restaurantCommission:
                                commissionData?.restaurantCommissionList?.restaurantCommission
                                    ?.commission,
                            restaurantCartCommission: updatedCartList,
                        };
                    }

                    return {
                        ...prev,
                        restaurantCartCommission: updatedCartList,
                    };

                });
            }
            setIsDeleting(false);
            setExpandedSections(false);
        } catch (error) {
            toast.error("An error occurred while deleting the Cart ...");
            console.error(error);
            setIsDeleting(false);
        }
    };

    const handleDeleteCart = async () => {
        const item: DeleteCartItem = {
            cartId:
                commissions?.restaurantCartCommission[index]?.cartId !== undefined
                    ? commissions?.restaurantCartCommission[index]?.cartId
                    : "",
            restaurantId: selectedRestaurantId,
        };

        Swal.fire({
            title: "Are you sure?",
            text: "You won't be Delete this Cart!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#590B21",
            cancelButtonColor: "#ddd",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                deleteCart(item);
            }
        });
    };

    const columns: TableColumn<Products>[] = [
        {
            name: <h6 className="fw-bold mx-3">Products</h6>,
            width: "300px",
            cell: (row) => (
                <div className="table-column-content">
                    <img
                        src={row.imageUrl}
                        alt={row.displayName}
                        style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "10px",
                            margin: "15px",
                        }}
                        onError={(e) => {
                            e.currentTarget.src = row.imageUrl;
                        }}
                    />
                    <span
                        style={{
                            marginLeft: "15px",
                            fontSize: "14px",
                            fontWeight: "bold",
                        }}
                    >
                        {row.displayName}
                    </span>
                </div>
            ),
            sortable: false,
        },
        {
            name: <h6 className="fw-bold ms-4">Commission</h6>,
            cell: (row) => (
                <div
                    className="table-column-content me-4"
                    style={{ fontSize: "14px", fontWeight: "bold" }}
                >{`${row.commission} %`}</div>
            ),
            sortable: false,
            right: true,
        },
        {
            name: <h6 className="fw-bold table-action-column">Action</h6>,
            selector: (row) => "action",
            cell: (row) => (
                <div className="table-action-column">
                    &nbsp;
                    <Button
                        size={"sm"}
                        variant="light"
                        style={{
                            backgroundColor: "transparent",
                            border: "0.5px solid red",
                        }}
                        onClick={() => handleRemoveProduct(row)}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} style={{ color: "red" }} />
                    </Button>
                </div>
            ),
            sortable: false,
            right: true,
        },
    ];

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (
            selectedProduct !== null &&
            selectedProduct !== undefined &&
            productCommissionWatcher !== null &&
            productCommissionWatcher !== undefined
        ) {
            setIsAddButtonDisable(false);
        } else {
            if (commissions?.systemDefaultCommission + 2 < productCommissionWatcher)
                setIsAddButtonDisable(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedProduct, productCommissionWatcher]);

    useEffect(() => {
        if (cartCommissionWatcher !== null && cartCommissionWatcher !== undefined) {
            setCommissions((prev: Commissions) => {
                return {
                    ...prev,
                    restaurantCartCommission: prev.restaurantCartCommission.map(
                        (cart, index) => {
                            if (index === updateCartIndex) {
                                const newCartCommission = parseInt(
                                    cartCommissionWatcher ?? "0",
                                    10
                                );
                                return {
                                    ...cart,
                                    commission: newCartCommission,
                                };
                            }
                            return cart;
                        }
                    ),
                };
            });

            if (
                restaurantCommissionWatcher > commissions?.systemDefaultCommission &&
                cartCommissionWatcher > restaurantCommissionWatcher
            ) {
                setIsErrorCartCommission(false);
            } else {
                setIsErrorCartCommission(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartCommissionWatcher]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (
            productCommissionWatcher !== null &&
            productCommissionWatcher !== undefined
        ) {
            setCommissions((prev: Commissions) => {
                return {
                    ...prev,
                    restaurantCartCommission: prev.restaurantCartCommission.map(
                        (cart, index) => {
                            if (index === updateCartIndex) {
                                const newCartCommission = parseInt(
                                    cartCommissionWatcher ?? "0",
                                    10
                                );
                                return {
                                    ...cart,
                                    commission: newCartCommission,
                                };
                            }
                            return cart;
                        }
                    ),
                };
            });

            if (
                productCommissionWatcher > cartCommissionWatcher &&
                cartCommissionWatcher > restaurantCommissionWatcher &&
                isProductSelected
            ) {
                setIsErrorProductCommission(false);
            } else {
                if (productCommissionWatcher === "") {
                    setIsErrorProductCommission(false);
                } else {
                    setIsErrorProductCommission(true);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productCommissionWatcher]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (cartCommission) {
            setValue(
                `cartCommission-${cartCommission.cartId}`,
                cartCommission.commission
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartCommission]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const currentCartProducts: MenuItem[] = [
        isNewCart
            ? newCartCommissionProduct !== undefined
                ? newCartCommissionProduct.map((product: Products) => ({
                    id: product.menuItemId,
                    displayName: product.displayName,
                    imageUrl: product.imageUrl,
                    price: 0,
                    restaurantId: "",
                    isAvailable: true,
                    status: "",
                    createdAt: { _nanoseconds: 0, _seconds: 0 },
                    availableDays: null,
                }))
                : []
            : Array.isArray(commissions?.restaurantCartCommission[index]?.products) &&
                commissions !== undefined
                ? commissions?.restaurantCartCommission[index]?.products.map(
                    (product: Products) => ({
                        id: product.menuItemId,
                        displayName: product.displayName,
                        imageUrl: product.imageUrl,
                        price: 0,
                        restaurantId: "",
                        isAvailable: true,
                        status: "",
                        createdAt: { _nanoseconds: 0, _seconds: 0 },
                        availableDays: null,
                    })
                )
                : [],
    ].flat();

    const filteredProductsData = productsData
        ? productsData.filter(
            (product: MenuItem) =>
                !currentCartProducts.some(
                    (currentProduct: MenuItem) =>
                        currentProduct.displayName === product.displayName
                )
        )
        : [];

    return (
        <div>
            {isCardVisible && (
                <Card className="card-commission">
                    <CardHeader style={{ backgroundColor: "#fff" }}>
                        <div className="d-flex justify-content-between align-items-center">
                            <strong className="text-secondary">
                                {isNewCart
                                    ? `Add New Cart Commission`
                                    : `${cartCommission?.cartName}`}
                            </strong>
                            <div>
                                {isNewCart && (
                                    <Button
                                        color="link"
                                        onClick={() => { setIsCardVisible(false); setIsAddNewCart(false) }}
                                        className="cart-commision-add-cart-close-btn"
                                    >
                                        <FontAwesomeIcon icon={faTimes} />
                                    </Button>
                                )}
                                <Button
                                    color="link"
                                    onClick={toggleSection}
                                    style={{
                                        fontSize: "18px",
                                        textDecoration: "none",
                                        color: "#007bff",
                                        backgroundColor: "transparent",
                                        border: "0.5px solid #ccc",
                                    }}
                                >
                                    {expandedSections ? (
                                        <FontAwesomeIcon icon={faChevronUp} />
                                    ) : (
                                        <FontAwesomeIcon icon={faChevronDown} />
                                    )}
                                </Button>
                            </div>
                        </div>
                    </CardHeader>
                    <Collapse isOpen={expandedSections}>
                        <CardBody>
                            <hr />
                            <Row>
                                {isNewCart && (
                                    <Col lg="8">
                                        <ControlledSelectForFiltering
                                            inputName={"cartName"}
                                            placeholder={"Enter Cart"}
                                            label={"Cart"}
                                            rules={{ required: false }}
                                            errors={errors}
                                            control={control}
                                            optionsList={cartsList.map((cart: any) => ({
                                                label: cart.displayName,
                                                value: cart.id,
                                            }))}
                                        />
                                    </Col>
                                )}

                                <Col lg="4">
                                    <ControlledTextField
                                        inputName={`cartCommission-${isNewCart ? `new` : cartCommission?.cartId
                                            }`}
                                        inputType={"number"}
                                        placeholder={"Enter Commission"}
                                        label={"Cart Commission"}
                                        hasSideLabel={true}
                                        sideLabel={"%"}
                                        rules={{
                                            required: false,
                                            pattern: /^[0-9]*$/,
                                            min: 0,
                                            max: 100,
                                        }}
                                        errors={errors}
                                        control={control}
                                    // focusOn={isErrorCartCommission}
                                    />
                                </Col>
                                {/*error*/}
                                {isErrorCartCommission && isCartSave && (
                                    <span className="text-danger py-2">
                                        Cart commission should be higher than the restaurant
                                        commission.
                                    </span>
                                )}
                            </Row>

                            <Row className="mt-2">
                                <Col lg="8">
                                    <Label>Products</Label>
                                    <Select<MenuItem>
                                        options={filteredProductsData.map((option: MenuItem) => ({
                                            ...option,
                                            isDisabled: !option.isAvailable,
                                        }))}
                                        value={selectedProduct}
                                        onChange={handleSelectProduct}
                                        filterOption={() => true}
                                        getOptionLabel={(option) => option.displayName}
                                        formatOptionLabel={(option) => (
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <img
                                                    src={option.imageUrl}
                                                    alt="Product"
                                                    style={{
                                                        width: "35px",
                                                        height: "35px",
                                                        marginRight: "8px",
                                                    }}
                                                    className="img-fluid img-thumbnail"
                                                />
                                                <span>{option.displayName}</span>
                                                {!option.isAvailable && (
                                                    <Badge
                                                        color={"warning"}
                                                        style={{ marginLeft: "5px", opacity: 0.7 }}
                                                    >
                                                        Not Available
                                                    </Badge>
                                                )}
                                            </div>
                                        )}
                                        getOptionValue={(option) => option.displayName}
                                        placeholder="Select a Product"
                                    />
                                </Col>
                                <Col lg="3">
                                    <ControlledTextField
                                        inputName={`productCommission-${isNewCart ? `new` : cartCommission?.cartId
                                            }`}
                                        inputType={"number"}
                                        placeholder={""}
                                        label={"Commission"}
                                        hasSideLabel={true}
                                        sideLabel={"%"}
                                        rules={{
                                            required: false,
                                            pattern: /^[0-9]*$/,
                                            min: 0,
                                            max: 100,
                                        }}
                                        errors={errors}
                                        control={control}
                                    // focusOn={isErrorProductCommission && isProductSelected}
                                    />
                                </Col>
                                <Col lg="1" className="d-flex justify-content-center align-items-end pb-1">
                                    <Button
                                        className="products-add-btn"
                                        onClick={handleAddProduct}
                                        disabled={isAddButtonDisable && isErrorProductCommission}
                                    >
                                        <FontAwesomeIcon icon={faAdd} />
                                    </Button>
                                </Col>
                                {/*error*/}
                                {isErrorProductCommission && (
                                    <span className="text-danger py-2">
                                        Product commissions should be higher than the cart commissions
                                        and restaurant commission.
                                    </span>
                                )}
                            </Row>

                            <div className="border rounded mt-3">
                                { }
                                <DataTable
                                    columns={columns}
                                    data={
                                        isNewCart
                                            ? newCartCommissionProduct !== undefined
                                                ? newCartCommissionProduct
                                                : []
                                            : Array.isArray(
                                                commissions?.restaurantCartCommission[index]?.products
                                            ) && commissions !== undefined
                                                ? commissions?.restaurantCartCommission[index]?.products
                                                : []
                                    }
                                    responsive
                                    pagination
                                    highlightOnHover
                                    pointerOnHover
                                    noDataComponent={<div>No Commission Products found</div>}
                                    progressComponent={
                                        <div className="text-center py-4">
                                            <TableLoadingComponent numColumns={3} />
                                        </div>
                                    }
                                />
                            </div>
                            <div className="d-flex justify-content-end py-3">
                                {!isNewCart && (
                                    <div>
                                        <ButtonComponent
                                            titel={isDeleting ? "Deleting" : "Delete"}
                                            onClick={handleDeleteCart}
                                            icon={isDeleting ? <FontAwesomeIcon icon={faSpinner} spin /> : null}
                                            isDisabled={isDeleting}
                                        />
                                    </div>
                                )}
                                {isSaving ? (<SavingButton isSaving={isSaving} />
                                ) : (<ButtonComponent
                                    titel={"Save"}
                                    onClick={handleSaveCommission}
                                    isDisabled={false}
                                />)}
                                {/* <ButtonComponent titel="Save" onClick={handleSaveCommission} /> */}
                            </div>
                        </CardBody>
                    </Collapse>
                </Card>
            )}
        </div>
        // <div>
        //     <Card className="card-commission">
        //         <CardHeader style={{ backgroundColor: "#fff" }}>
        //             <div className="d-flex justify-content-between align-items-center">
        //                 <strong className="text-secondary">
        //                     {isNewCart
        //                         ? `Add New Cart Commission`
        //                         : `${cartCommission?.cartName}`}
        //                 </strong>
        //                 <Button
        //                     color="link"
        //                     onClick={toggleSection}
        //                     style={{
        //                         fontSize: "18px",
        //                         textDecoration: "none",
        //                         color: "#007bff",
        //                         backgroundColor: "transparent",
        //                         border: "0.5px solid #ccc",
        //                     }}
        //                 >
        //                     {expandedSections ? (
        //                         <FontAwesomeIcon icon={faChevronUp} />
        //                     ) : (
        //                         <FontAwesomeIcon icon={faChevronDown} />
        //                     )}
        //                 </Button>
        //             </div>
        //         </CardHeader>

        //         <Collapse isOpen={expandedSections}>
        //             <CardBody>
        //                 <hr />
        //                 <Row>
        //                     {isNewCart && (
        //                         <Col lg="8">
        //                             <ControlledSelectForFiltering
        //                                 inputName={"cartName"}
        //                                 placeholder={"Enter Cart"}
        //                                 label={"Cart"}
        //                                 rules={{ required: false }}
        //                                 errors={errors}
        //                                 control={control}
        //                                 optionsList={cartsList.map((cart: any) => ({
        //                                     label: cart.displayName,
        //                                     value: cart.id,
        //                                 }))}
        //                             />
        //                         </Col>
        //                     )}

        //                     <Col lg="4">
        //                         <ControlledTextField
        //                             inputName={`cartCommission-${isNewCart ? `new` : cartCommission?.cartId
        //                                 }`}
        //                             inputType={"number"}
        //                             placeholder={"Enter Commission"}
        //                             label={"Cart Commission"}
        //                             hasSideLabel={true}
        //                             sideLabel={"%"}
        //                             rules={{
        //                                 required: false,
        //                                 pattern: /^[0-9]*$/,
        //                                 min: 0,
        //                                 max: 100,
        //                             }}
        //                             errors={errors}
        //                             control={control}
        //                         // focusOn={isErrorCartCommission}
        //                         />
        //                     </Col>
        //                     {/*error*/}
        //                     {isErrorCartCommission && isCartSave && (
        //                         <span className="text-danger py-2">
        //                             Cart commission should be higher than the restaurant
        //                             commission.
        //                         </span>
        //                     )}
        //                 </Row>

        //                 <Row className="mt-2">
        //                     <Col lg="8">
        //                         <Label>Products</Label>
        //                         <Select<MenuItem>
        //                             options={filteredProductsData.map((option: MenuItem) => ({
        //                                 ...option,
        //                                 isDisabled: !option.isAvailable,
        //                             }))}
        //                             value={selectedProduct}
        //                             onChange={handleSelectProduct}
        //                             filterOption={() => true}
        //                             getOptionLabel={(option) => option.displayName}
        //                             formatOptionLabel={(option) => (
        //                                 <div style={{ display: "flex", alignItems: "center" }}>
        //                                     <img
        //                                         src={option.imageUrl}
        //                                         alt="Product"
        //                                         style={{
        //                                             width: "35px",
        //                                             height: "35px",
        //                                             marginRight: "8px",
        //                                         }}
        //                                         className="img-fluid img-thumbnail"
        //                                     />
        //                                     <span>{option.displayName}</span>
        //                                     {!option.isAvailable && (
        //                                         <Badge
        //                                             color={"warning"}
        //                                             style={{ marginLeft: "5px", opacity: 0.7 }}
        //                                         >
        //                                             Not Available
        //                                         </Badge>
        //                                     )}
        //                                 </div>
        //                             )}
        //                             getOptionValue={(option) => option.displayName}
        //                             placeholder="Select a Product"
        //                         />
        //                     </Col>
        //                     <Col lg="3">
        //                         <ControlledTextField
        //                             inputName={`productCommission-${isNewCart ? `new` : cartCommission?.cartId
        //                                 }`}
        //                             inputType={"number"}
        //                             placeholder={""}
        //                             label={"Commission"}
        //                             hasSideLabel={true}
        //                             sideLabel={"%"}
        //                             rules={{
        //                                 required: false,
        //                                 pattern: /^[0-9]*$/,
        //                                 min: 0,
        //                                 max: 100,
        //                             }}
        //                             errors={errors}
        //                             control={control}
        //                         // focusOn={isErrorProductCommission && isProductSelected}
        //                         />
        //                     </Col>
        //                     <Col lg="1" className="d-flex justify-content-center align-items-end pb-1">
        //                         <Button
        //                             className="products-add-btn"
        //                             onClick={handleAddProduct}
        //                             disabled={isAddButtonDisable && isErrorProductCommission}
        //                         >
        //                             <FontAwesomeIcon icon={faAdd} />
        //                         </Button>
        //                     </Col>
        //                     {/*error*/}
        //                     {isErrorProductCommission && (
        //                         <span className="text-danger py-2">
        //                             Product commissions should be higher than the cart commissions
        //                             and restaurant commission.
        //                         </span>
        //                     )}
        //                 </Row>

        //                 <div className="border rounded mt-3">
        //                     <DataTable
        //                         columns={columns}
        //                         data={
        //                             isNewCart
        //                                 ? newCartCommissionProduct !== undefined
        //                                     ? newCartCommissionProduct
        //                                     : []
        //                                 : Array.isArray(
        //                                     commissions?.restaurantCartCommission[index]?.products
        //                                 ) && commissions !== undefined
        //                                     ? commissions?.restaurantCartCommission[index]?.products
        //                                     : []
        //                         }
        //                         responsive
        //                         pagination
        //                         highlightOnHover
        //                         pointerOnHover
        //                         noDataComponent={<div>No Commission Products found</div>}
        //                     />
        //                 </div>
        //                 <div className="d-flex justify-content-end py-3">
        //                     {!isNewCart && (
        //                         <div>
        //                             <ButtonComponent
        //                                 titel={isDeleting ? "Deleting" : "Delete"}
        //                                 onClick={handleDeleteCart}
        //                                 icon={isDeleting ? <FontAwesomeIcon icon={faSpinner} spin /> : null}
        //                                 isDisabled={isDeleting}
        //                             />
        //                         </div>
        //                     )}
        //                     {isSaving ? (<SavingButton isSaving={true} />
        //                     ) : (<ButtonComponent
        //                         titel={"Save"}
        //                         onClick={handleSaveCommission}
        //                         isDisabled={false}
        //                     />)}
        //                     {/* <ButtonComponent titel="Save" onClick={handleSaveCommission} /> */}
        //                 </div>
        //             </CardBody>
        //         </Collapse>
        //     </Card>
        // </div>
    );
};

export default CartCommissionForm;
